import { Cog8ToothIcon, LockClosedIcon, BoltIcon } from '@heroicons/react/24/outline'

const features = [
  {
    name: 'Comprehensive Know-How',
    description:
      'Our experts possess extensive knowledge in all upstream and downstream manufacturing processes related to hydroforming.',
    icon: Cog8ToothIcon,
  },
  {
    name: 'Quality Assurance',
    description:
      'With our in-house capabilities, we maintain strict quality control standards, ensuring that each hydroformed tube meets or exceeds your expectations',
    icon: LockClosedIcon,
  },
  {
    name: 'Efficiency and Speed',
    description:
      'By managing all processes internally, we minimize delays and streamline production, providing you with shorter lead times.',
    icon: BoltIcon,
  },
]

export default function Whyus() {
  return (
    <div className="bg-white py-16 lg:pt-8 lg:pb-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <h2 className="mt-2 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
          Why Choose Us as your Aluminum Tube Hydroforming Supplier?
          </h2>
        </div>
        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-full">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-10 lg:max-w-none lg:grid-cols-3 lg:gap-y-16">
            {features.map((feature) => (
              <div key={feature.name} className="relative pl-16">
                <dt className="text-lg font-semibold leading-7 text-gray-900">
                  <div className="absolute left-0 top-0 flex h-10 w-10 items-center justify-center rounded-lg bg-slate-600">
                    <feature.icon className="h-6 w-6 text-white" aria-hidden="true" />
                  </div>
                  {feature.name}
                </dt>
                <dd className="mt-2 text-lg leading-7 text-slate-600">{feature.description}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </div>
  )
}